import { IterableMap } from "@redotech/react-util/component";
import { useHandler } from "@redotech/react-util/hook";
import XCloseIconSvg from "@redotech/redo-icons/x-close.svg";
import { ReactElement, memo } from "react";
import { RedoButton } from "../buttons/redo-button";

export interface FilterComponent<T = string> {
  name: string;
  render(props: { value: T; setValue(value: T): void }): ReactElement;
}

export interface FilterChipsListProps {
  filterComponents: FilterComponent[];
  selectedFilters: string[];
  filters: Record<string, string>;
  onFiltersChange: (filters: Record<string, string>) => void;
  onSelectedFiltersChange: (selectedFilters: string[]) => void;
}

export const FilterChipsList = memo(function FilterChipsList({
  filterComponents,
  selectedFilters,
  filters,
  onFiltersChange,
  onSelectedFiltersChange,
}: FilterChipsListProps) {
  const handleClearAll = useHandler(() => {
    onSelectedFiltersChange([]);
    onFiltersChange(
      Object.fromEntries(
        filterComponents.map((component) => [component.name, ""]),
      ),
    );
  });

  return (
    <>
      <IterableMap
        items={filterComponents.filter((component) =>
          selectedFilters.includes(component.name),
        )}
        keyFn={(component) => component.name}
      >
        {(component) => {
          function setValue(value: string) {
            onFiltersChange({ ...filters, [component.name]: value });
          }
          // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
          return component.render({ value: filters[component.name], setValue });
        }}
      </IterableMap>
      <RedoButton
        hierarchy="secondary"
        IconLeading={XCloseIconSvg}
        onClick={handleClearAll}
        size="sm"
        text="Clear all filters"
      />
    </>
  );
});
